import React from 'react';
import "./certificates.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';
import image1 from "./images/ML.png";
import image2 from "./images/WEB1.png";
import image3 from "./images/WEB2.png";
import image4 from "./images/WEB_COURSERA.png";
import image5 from "./images/nvidia.png";
import image6 from "./images/nvdia2.png";
import image7 from "./images/nvdia3.png";
import image9 from "./images/nvdia5.png";
import image10 from "./images/nvdia6.png";
import image11 from "./images/nvdia7.png";
import image12 from "./images/samsung.png";



const Certificates = () => {
  const images = [image1, image2, image3, image4,image5,image6,image7,image9,image10,image11,image12];
  
  return (
    <section className="certificates section" id='certificate'>
      <h2 className="section__title">Certificates</h2>
      <OptimizedSlideshow mediaItems={images} />
    </section>
  );
};

export default Certificates;
